// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1uZF-","buttons":"SendReceipts_buttons__MwG7D","email":"SendReceipts_email__3eJz_","bookApptTitle":"SendReceipts_bookApptTitle__2e2Z8"};